import React from "react";
import SignUp from "./SignUp/SignUp";

const SignUpPage = () => {
  return <SignUp />;
};

export default SignUpPage;
